// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8146) return "static/css/8146.238099f432e03407e221.css";
	if (chunkId === 6204) return "static/css/receiver.b9e5c2fbaa2322950312.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2006":"ea9798e5fd931e89d597","6559":"b2e5d3c087a7fdcef4f6","6918":"ea9798e5fd931e89d597","7076":"ea9798e5fd931e89d597"}[chunkId] + ".chunk.css";
};